import React from 'react'
import { Herosection } from './Herosection'

export const HomePage = () => {
  return (
    <div><Herosection/></div>
  )
}
